import { validateName } from './customCommands.identifiers';

// 2023-11-29 - Code moved from index.js

// String -> void
const validateParamName = validateName('parameter');

// (String | Parameter) -> Parameter
function normalizeParameter(param) {
    if (typeof param === 'string') {
        validateParamName(param);

        return { name: param };
    }

    if (typeof param.name !== 'string') {
        throw new Error(
            'All command parameters must be a string value or be an object with a .name property',
        );
    }

    validateParamName(param.name);

    return param;
}

// [String | Parameter] -> [Parameter]
export const prepareParameters = (definition) =>
    (definition.parameters || []).map(normalizeParameter);
